export default __webpack_public_path__ + "assets/Onboarding_9_4_B.png";